import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { getImageUrl } from "../common/Funcation";
const velkiAgBg = `${process.env.PUBLIC_URL || ""}/velki-ag-bg.jpg`;

type VelkiAgLoginProps = {
  site: any;
  formData: {
    username: string;
    password: string;
    validationCode: string;
  };
  onChange: (e: any) => void;
  onSubmit: (e: any) => void;
  validator: any;
  isSubmitting: boolean;
  showPassword: boolean;
  setShowPassword: (value: boolean) => void;
  isCaptcha: boolean;
  confirmationCode: number;
  isValidationWrong: boolean;
  showAppLink: boolean;
  onDownloadApp: () => void;
};

const VelkiAgLogin = ({
  site,
  formData,
  onChange,
  onSubmit,
  validator,
  isSubmitting,
  showPassword,
  setShowPassword,
  isCaptcha,
  confirmationCode,
  isValidationWrong,
  showAppLink,
  onDownloadApp,
}: VelkiAgLoginProps) => {
  const logoUrl = getImageUrl(
    site?.agLoginLogo || site?.adminLogo || site?.logo,
  );
  const usernameError = validator.current.message(
    "userName",
    formData.username,
    "required",
  );
  const passwordError = validator.current.message(
    "password",
    formData.password,
    "required",
  );
  const codeError = validator.current.message(
    "validationCode",
    formData.validationCode,
    "required",
  );
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== "undefined" && window.outerWidth < 900,
  );

  useEffect(() => {
    const meta = document.querySelector('meta[name="viewport"]');
    const previous = meta?.getAttribute("content") || "width=1350";
    meta?.setAttribute(
      "content",
      "width=device-width, initial-scale=1, viewport-fit=cover",
    );
    document.body.classList.add("velki-ag-active");
    document.documentElement.classList.add("velki-ag-active");
    document.documentElement.classList.add("velki-ag-boot");

    const sync = () => {
      setIsMobile(window.outerWidth < 900 || window.innerWidth < 768);
    };
    sync();
    window.addEventListener("resize", sync);
    return () => {
      window.removeEventListener("resize", sync);
      meta?.setAttribute("content", previous);
      document.body.classList.remove("velki-ag-active");
      document.documentElement.classList.remove("velki-ag-active");
      document.documentElement.classList.remove("velki-ag-boot");
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>{site?.title}</title>
      </Helmet>
      <div
        className={`velki-ag-login${isMobile ? " is-mobile" : ""}`}
        style={{ backgroundImage: `url(${velkiAgBg})` }}
      >
        <div className="velki-ag-panel">
          {logoUrl ? (
            <img
              className="velki-ag-logo"
              src={logoUrl}
              alt={site?.title || "Agent"}
            />
          ) : (
            <div className="velki-ag-logo velki-ag-logo--empty" />
          )}
          <form className="velki-ag-form" onSubmit={onSubmit}>
            <h3 className="velki-ag-title">
              <span>Agent</span> Sign in
            </h3>
            <div className="velki-ag-field">
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={onChange}
                placeholder="Username"
                disabled={isSubmitting}
                autoComplete="username"

              />
              {usernameError ? (
                <span className="velki-ag-error">{usernameError}</span>
              ) : null}
            </div>
            <div className="velki-ag-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={onChange}
                placeholder="Password"
                disabled={isSubmitting}
                autoComplete="current-password"
                style={{ marginTop: "9px" }}
              />
              <button
                type="button"
                className="velki-ag-eye"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? "Hide password" : "Show password"}

              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  {showPassword ? (
                    <path d="M3 3l18 18M10.6 10.6A3 3 0 0012 15a3 3 0 002.4-4.8M9.9 5.2A10.8 10.8 0 0112 5c5 0 9.3 3.1 11 7.5a11.7 11.7 0 01-4.1 5.2M6.1 6.1A11.8 11.8 0 001 12.5C2.7 16.9 7 20 12 20c1.1 0 2.2-.2 3.2-.5" />
                  ) : (
                    <path d="M1 12.5C2.7 8.1 7 5 12 5s9.3 3.1 11 7.5C21.3 16.9 17 20 12 20S2.7 16.9 1 12.5zM12 16a3.5 3.5 0 100-7 3.5 3.5 0 000 7z" />
                  )}
                </svg>
              </button>
              {passwordError ? (
                <span className="velki-ag-error">{passwordError}</span>
              ) : null}
            </div>
            {isCaptcha && (
              <div className="velki-ag-field velki-ag-field--code">
                <input
                  type="text"
                  inputMode="numeric"
                  name="validationCode"
                  value={formData.validationCode}
                  onChange={onChange}
                  placeholder="Validation Code"
                  disabled={isSubmitting}
                  autoComplete="off"
                  style={{ marginTop: "9px" }}
                />
                <span className="velki-ag-code">{confirmationCode}</span>
                {codeError ? (
                  <span className="velki-ag-error">{codeError}</span>
                ) : null}
              </div>
            )}
            {isValidationWrong ? (
              <span className="velki-ag-error">invalid verification code</span>
            ) : null}
            <button
              type="submit"
              className={`velki-ag-submit${isSubmitting ? " is-loading" : ""}`}
              disabled={isSubmitting}
              style={{ marginTop: "9px" }}
            >
              <span>{isSubmitting ? "Logging in..." : "Login"}</span>
              {!isSubmitting && (
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
              )}
            </button>
            {showAppLink && (
              <button
                type="button"
                className="velki-ag-apk"
                onClick={onDownloadApp}
              >
                <img src="/images/btn-android-dl.png" alt="download app button" />
              </button>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default VelkiAgLogin;
